import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppFileLibrary } from 'components/Common/AppFileLibrary/AppFileLibrary.component'
import {
  useUploadUserFiles,
  useUserFiles,
} from 'components/Common/AppFileLibrary/AppFileLibrary.hook'

const Files = ({ userId, userFiles, getUserFilesAction, saveUserFileAction }) => {
  const { t } = useTranslation()
  const { reload, isLoading, isError } = useUserFiles(getUserFilesAction, userId)
  const { upload, isUploading, recentIds } = useUploadUserFiles({
    userId,
    files: userFiles,
    saveUserFileAction,
  })

  return (
    <div className="col-span-12 mdl:col-span-4 px-1">
      {/* A new panel for each client, so it never keeps showing another client's list */}
      <AppFileLibrary
        key={userId}
        files={userFiles}
        isLoading={isLoading}
        isError={isError}
        onRetry={reload}
        onUpload={upload}
        isUploading={isUploading}
        recentIds={recentIds}
        variant="plain"
        emptyBody={t('files.emptyBodyClient')}
      />
    </div>
  )
}

export default Files
